export default {
  LIST: 'LIST',
  GRID: 'GRID',
  DEFAULT_GRID: 'DEFAULT_GRID',
  DEFAULT_LIST: 'DEFAULT_LIST',
};



// WEBPACK FOOTER //
// ./src/const/layout_type.js